import Button from '@/common/components/base/button/Button';
import LoadingButton from '@/common/components/base/button/loadingButton';
import { FileTypeConst } from '@/common/types/Files.type';
import { getInitialPreviousCorrectiveImagesQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialPreviousCorrectiveImages/getInitialPreviousCorrectiveImagesQueryOptions';
import { getPreviousCorrectiveImagesOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getPreviousCorrectiveImages/getPreviousCorrectiveImagesOptions';
import { postDamagedVehicleCorrectiveImagesOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postDamagedVehicleCorrectiveImages/postDamagedVehicleCorrectiveImagesOptions';
import { useCorrectiveImages } from '@/modules/adjusterReportModules/IncidentParticipants/store/correctiveImages/useCorrectiveImages';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';

const PostButton = ({ type }: { type?: FileTypeConst }) => {
  const { mutateAsync: PostDamaged, isPending } = useMutation(
    postDamagedVehicleCorrectiveImagesOptions(),
  );
  const client = useQueryClient();
  const { damagedId, id } = useParams();
  const { selectedDamagedParts, selectedDocuments, selectedVehicle, reset } =
    useCorrectiveImages();
  const validButton = useMemo(() => {
    if (
      selectedDamagedParts.length !== 0 ||
      selectedDocuments.length !== 0 ||
      selectedVehicle.length !== 0
    ) {
      return false;
    }
    return true;
  }, [selectedDamagedParts, selectedDocuments, selectedVehicle]);

  const onSubmit = () => {
    PostDamaged({
      damagedId: +damagedId!,
      id: +id!,
      body: {
        damaged: selectedDamagedParts.map((item) => item.enNameOrId),
        document: selectedDocuments.map((item) => item.enNameOrId),
        vehicle: selectedVehicle.map((item) => item.enNameOrId),
      },
      type: type,
    }).then(() => {
      type !== 'initial'
        ? client.invalidateQueries({
            queryKey: getPreviousCorrectiveImagesOptions({
              damaged_id: +damagedId!,
              id: +id!,
            }).queryKey,
          })
        : client.invalidateQueries({
            queryKey: getInitialPreviousCorrectiveImagesQueryOptions({
              id: +id!,
            }).queryKey,
          });

      reset();
    });
  };

  return (
    <Box>
      <Flex gap={8}>
        <Button
          w="100%"
          mt={40}
          onClick={onSubmit}
          disabled={validButton || isPending}
        >
          {isPending && <LoadingButton color={'primary'} loading={isPending} />}
          ثبت
        </Button>
      </Flex>
    </Box>
  );
};

export default PostButton;
